import React from 'react';
import '../../styles/design-system.css';

/**
 * Card Component
 * Professional card container matching iLovePDF design
 * 
 * @param {Object} props
 * @param {string} props.variant - 'default' | 'elevated' | 'outlined'
 * @param {string} props.padding - 'compact' | 'default' | 'spacious'
 * @param {boolean} props.hoverable - Add hover effect
 * @param {React.ReactNode} props.children - Card content
 */
const Card = ({
    variant = 'default',
    padding = 'default',
    hoverable = false,
    children,
    className = '',
    ...props
}) => {
    const baseClass = 'card';
    const variantClass = variant !== 'default' ? `card-${variant}` : '';
    const paddingClass = padding !== 'default' ? `card-${padding}` : '';

    const classes = [
        baseClass,
        variantClass,
        paddingClass,
        className
    ].filter(Boolean).join(' ');

    const style = hoverable ? { cursor: 'pointer' } : {};

    return (
        <div className={classes} style={style} {...props}>
            {children}
        </div>
    );
};

export default Card;
